NtechApp.Map = function($view, mapControls, filters) {
    var me = this;

    this._$view = null;
    this._mapControls = null;
    this._filters = null;

    this._click = null;
    this._sizesResolver = null;
    this._ajax = null;

    this._loader = null;
    this._overlay = null;

    this._map = null;
    this._mapMarkers = [];

    this._nextLoadRequestData = null;
    this._lastLoadRequestData = null;
    this._isMapDataLoading = false;

    this._lastResizeDocumentHeight = null;
    this._jobsData = null;
    // [
    //     {lat: X, lng: y, restaurantsData: [
    //          [job1Data, job2Data],
    //          [job1Data, job2Data]
    //      ]}   
    // ]
    this._groupedByCoordsJobsData = [];

    this._construct = function () {
        if($(window).scrollTop() > 0)
            $(window).scrollTop(0);

        me._$view = $view;
        me._mapControls = mapControls;
        me._filters = filters;

        me._click = new NtechApp.TouchClickEvent();
        me._sizesResolver = new NtechApp.SizesResolver();
        me._ajax = new NtechApp.Ajax();

        me._loader = new NtechApp.Loader(
            35, 35, "absolute", this._$view.find(".mapWrapper")
        );
        me._overlay = new NtechApp.Overlay(
            this._$view.find(".mapWrapper"),
            {position: "absolute"}
        );

        me._lastResizeDocumentHeight = $(document).height();
        me._updateMapWrapperHeight();
        me._createMap(function(startCoords) {
            me._afterMapCreate.call(me, startCoords);
        });
    },

    this._afterMapCreate = function(startCoords) {
        me._loadJobsData(
            NtechApp.Map.LOAD_JOB_TYPES.COORDS,
            me._filters.getSelectedFilterData(),
            null,
            null,
            startCoords
        );

        me._bindEvents();
    }

    this._bindEvents = function () {
        var me = this;

        $(window).on(NtechApp.Map.EVENT_WINDOW_RESIZE, function() {
            me._lastResizeDocumentHeight = $(document).height();
            me._updateMapWrapperHeight();
        });
        $(document).on(NtechApp.Map.EVENT_DOCUMENT_SCROLL, function() {
            me._updateMapWrapperHeight();
        });

        $(me._filters).on(NtechApp.Filters.EVENT_FILTER_CHANGE, function(event, filtersData) {
            me._loadJobsData(
                me._lastLoadRequestData.loadJobType,
                filtersData,
                me._lastLoadRequestData.zipCodeId,
                me._lastLoadRequestData.distance,
                me._lastLoadRequestData.mapCenterCoords,
                true,
                me._lastLoadRequestData.cityId
            );
        });

        var mapControls = NtechApp.MapControls;
        $(me._mapControls).on(mapControls.EVENT_ZIP_CONTROL_CHANGE, function(e, zipCodeId, distance) {
            me._loadJobsData(
                NtechApp.Map.LOAD_JOB_TYPES.ZIP_CODES,
                me._filters.getSelectedFilterData(),
                zipCodeId,
                distance,
                me._lastLoadRequestData.mapCenterCoords,
                null,
                false
            );
        });

        $(me._mapControls).on(mapControls.EVENT_CITY_CONTROL_CHANGE, function(e, cityId) {
            me._loadJobsData(
                NtechApp.Map.LOAD_JOB_TYPES.CITIES,
                me._filters.getSelectedFilterData(),
                null,
                null,
                me._lastLoadRequestData.mapCenterCoords,
                false,
                cityId
            )
        });
    }

    this._unbindEvents = function () {
    }

    this.destruct = function () {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.Map.EVENT_WINDOW_RESIZE = "resize.NtechApp.Map.EventWindowResize";
NtechApp.Map.EVENT_DOCUMENT_SCROLL = "scroll.NtechApp.Map.EventDocumentScroll";
NtechApp.Map.EVENT_OPEN_JOB_POPUP = "NtechApp.Map.EventOpenJobPopup";
NtechApp.Map.EVENT_CLOSE_JOB_POPUP = "NtechApp.Map.EventCloseJobPopup";
NtechApp.Map.LOAD_JOB_TYPES = {
    COORDS: "coords",
    ZIP_CODES: "zipCodes",
    CITIES: "cities"
};

NtechApp.proto(NtechApp.Map, {
    _loaderOn: function() {
        this._loader.on();
        this._overlay.on();
    },

    _loaderOff: function() {
        this._loader.off();
        this._overlay.off();
    },

    _updateMapWrapperHeight: function() {
        var headerHeight = $("#mainNavigation").outerHeight();
        var mapControlsHeight = this._mapControls.getView().outerHeight();
        var footerHeight = $("#footer").outerHeight() + 2;

        var $mapView = this._$view;
        var mapViewStyles = this._sizesResolver.getComputedCss($mapView.get(0));
        var mapViewPaddingHeight = parseFloat(mapViewStyles.paddingTop);
        mapViewPaddingHeight += parseFloat(mapViewStyles.paddingBottom);

        var contentHeight = headerHeight + mapControlsHeight + footerHeight;
        contentHeight += mapViewPaddingHeight;

        var $mapWrapper = this._$view.find(".mapWrapper");
        if($(document).scrollTop() == 0)
            $mapWrapper.css("height", $(window).height() - contentHeight + "px");
        else {
            $mapWrapper.css("height", this._lastResizeDocumentHeight - contentHeight + "px");
            google.maps.event.trigger(this._map, 'resize');
        }
    },

    _createMap: function(afterMapCreate) {
        var me = this;

        var initMap = function(startCoords) {
            me._map = new google.maps.Map(me._$view.find("#map").get(0), {
                center: startCoords,
                zoom: 10,
                mapTypeControl: false
            });

            afterMapCreate.call(me, startCoords);
        };

        this._initMapWithStartCoords(initMap);
    },

    _initMapWithStartCoords: function(initMap) {
        var lat = null;
        var lon = null;

        // Miami
        var defCoords = {lat: 25.94154, lng: -80.13861};

        if(NtechApp.isDev) {
            initMap(defCoords);
            return;
        }

        if(navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function(position) {
                lat = parseFloat(position.coords.latitude);
                lon = parseFloat(position.coords.longitude);

                initMap({lat: lat, lng: lon});
            });
        }
        else {
            initMap(defCoords);
            return;
        }
    },

    _loadJobsData: function(loadJobType,
                            filtersData,
                            zipCodeId,
                            distance,
                            coords,
                            disableMapCenterUpdate,
                            cityId) {
        if(typeof disableMapCenterUpdate == "undefined")
            var updateMapCenter = true;
        else if(disableMapCenterUpdate) {
            var updateMapCenter = false;
        }
        else
            var updateMapCenter = true;

        this._nextLoadRequestData = {
            loadJobType: loadJobType,
            filtersData: filtersData,
            zipCodeId: zipCodeId || null,
            distance: distance || null,
            coords: coords || null,
            updateMapCenter: updateMapCenter,
            cityId: cityId || null
        };
        if(this._isMapDataLoading)
            return;

        this._execLoadJobsData();
    },

    _execLoadJobsData: function() {
        var me = this;

        this._loaderOn();
        this._isMapDataLoading = true;

        var requestData = this._nextLoadRequestData;
        var params = {
            loadJobType: requestData.loadJobType,
            filtersData: requestData.filtersData,
            zipCodeId: requestData.zipCodeId,
            distance: requestData.distance,
            coords: requestData.coords,
            cityId: requestData.cityId,
            page: 0,
            responseType: "json"
        };

        this._nextLoadRequestData = null;

        me._ajax.get({
            url: Routing.generate('job_load_jobs_data', params),
            onSuccess: function(data) {
                me._updateMapData(data, requestData);
                me._groupJobsDataByCoordsAndRestaurants();
                me._clearMapMarkers();
                me._createMapMarkers();

                me._isMapDataLoading = false;
                if(me._nextLoadRequestData != null)
                    me._execLoadJobsData.call(me);
                me._showNotificationIfNoJobsFound();
            },
            onComplete: function() {
                if(me._nextLoadRequestData == null)
                    me._loaderOff();
            }
        });
    },

    _updateMapData: function(data, requestData) {
        var me = this;

        me._jobsData = data.jobs;
        me._lastLoadRequestData = requestData;

        if(me._jobsData == null)
            me._jobsData = [];

        me._lastLoadRequestData.mapCenterCoords = data.mapCenterCoords;
        me._$view.find(".locationMsg").text(data.locationMsg);

        if(requestData.updateMapCenter) {
            me._map.setCenter(new google.maps.LatLng(
                parseFloat(data.mapCenterCoords.lat),
                parseFloat(data.mapCenterCoords.lng)
            ));
        }
    },

    _groupJobsDataByCoordsAndRestaurants: function() {
        this._groupedByCoordsJobsData = [];

        for(var i = 0; i < this._jobsData.length; i++) {
            var jobData = this._jobsData[i];
            var coordsIndex = null;

            for(var j = 0; j < this._groupedByCoordsJobsData.length; j++) {
                if(this._groupedByCoordsJobsData[j].lat == jobData.lat && 
                   this._groupedByCoordsJobsData[j].lng == jobData.lon) {
                    coordsIndex = j;
                    break;
                }
            }

            if(coordsIndex == null) {
                this._groupedByCoordsJobsData.push({
                    lat: jobData.lat,
                    lng: jobData.lon,
                    restaurantsData: []
                });
                coordsIndex = this._groupedByCoordsJobsData.length - 1;
            }

            var restaurantDataIndex = null;
            for(var j = 0; j < this._groupedByCoordsJobsData[coordsIndex].restaurantsData.length; j++) {
                if(this._groupedByCoordsJobsData[coordsIndex].restaurantsData[j].id == jobData.account.id) {
                    restaurantDataIndex = j;
                    break;
                }
            }

            if(restaurantDataIndex == null) {
                this._groupedByCoordsJobsData[coordsIndex].restaurantsData.push({
                    id: jobData.account.id,
                    slug: jobData.account.slug,
                    address: jobData.account.address,
                    avatarUrl: jobData.account.avatarUrl,
                    fullName: jobData.account.fullName,
                    jobsData: []
                });
                restaurantDataIndex = this._groupedByCoordsJobsData[coordsIndex].restaurantsData.length - 1;
            }

            this._groupedByCoordsJobsData[coordsIndex].restaurantsData[restaurantDataIndex].jobsData.push(jobData);
        }
    },

    _clearMapMarkers: function() {
        for(var i = 0; i < this._mapMarkers.length; i++)
            this._mapMarkers[i].setMap(null);

        this._mapMarkers = [];
    },

    _createMapMarkers: function() {
        var me = this;

        for(var j = 0; j < this._groupedByCoordsJobsData.length; j++) {
            var data = this._groupedByCoordsJobsData[j];
            var coords = {
                lat: parseFloat(data.lat),
                lng: parseFloat(data.lng)
            };

            var jobsCount = 0;
            for(var i = 0; i < data.restaurantsData.length; i++) {
                jobsCount += data.restaurantsData[i].jobsData.length;
            }

            if(jobsCount == 1)
                var jobsCountText = "1 job offer.";
            else 
                var jobsCountText = jobsCount + " job offers.";

            this._mapMarkers.push(new google.maps.Marker({
                position: coords,
                map: this._map,
                title: jobsCountText
                //icon: this._$view.find("#map").attr("data-mapIcon")
            }));

            me._createMarkerPopupWindow(
                me._mapMarkers[me._mapMarkers.length - 1],
                data
            );
        }
    },

    _createMarkerPopupWindow: function(marker, data) {
        var me = this;

        var $popupWindow = $("<div/>").addClass("mapPopupWindow");
        var $popupContent = $("<div/>").addClass("popupContent");
        $popupWindow.append($popupContent);

        var itemHtml = this._createPopupContent(data);
        $popupContent.append($(itemHtml));

        var infowindow = new google.maps.InfoWindow({
            content: $popupWindow.get(0)
        });
        marker.addListener('click', function() {
            infowindow.open(me._map, marker);

            me._hideMapControls();
            $(me).trigger(NtechApp.Map.EVENT_OPEN_JOB_POPUP);
        });
        google.maps.event.addListener(infowindow, 'closeclick', function(){
            me._showMapControls();
            $(me).trigger(NtechApp.Map.EVENT_CLOSE_JOB_POPUP);
        });
    },

    _createPopupContent: function(data) {
        var itemsHtml = "";

        for(var i = 0; i < data.restaurantsData.length; i++) {
            var restaurantData = data.restaurantsData[i];
            var itemHtml = "";

            var restaurantRoute = NtechApp.config.baseUrl + Routing.generate('view_account_by_slug', {
                'slug': restaurantData.slug
            });
            var avatarUrl = restaurantData.avatarUrl;
            var fullName = restaurantData.fullName;
            
            var jobsCount = restaurantData.jobsData.length;
            var sublabel = (jobsCount == 1) ? "1 job offer" : (jobsCount + " job offers");

            itemHtml += '<div class="item">';
            itemHtml += '   <div class="headingWrapper">';
            itemHtml += '       <a href="' + restaurantRoute + '" target="_blank">';
            itemHtml += '           <div class="image">';
            itemHtml += '               <img src="' + avatarUrl + '"/>';
            itemHtml += '           </div>';
            itemHtml += '       </a>';
            itemHtml += '       <div class="content">';
            itemHtml += '           <div class="top">';
            itemHtml += '               <a href="' + restaurantRoute + '" target="_blank">' + fullName + '</a>';
            itemHtml += '           </div>';
            itemHtml += '           <div class="bottom">' + sublabel + '</div>';
            itemHtml += '       </div>';
            itemHtml += '   </div>';
            itemHtml += '   <div class="dataWrapper">';
            itemHtml += this._getJobsHtml(restaurantData);
            itemHtml += '   </div>';
            itemHtml += '</div>';

            itemsHtml += itemHtml;
        }

        return itemsHtml;
    },

    _getJobsHtml: function(data) {
        var itemsHtml = "";

        for(var i = 0; i < data.jobsData.length; i++) {
            var jobData = data.jobsData[i];
            var itemHtml = "";

            var jobRoute = NtechApp.config.baseUrl + Routing.generate('view_business_account_job', {
                'jobId': jobData.id
            });

            itemHtml += '       <div class="jobItem">';
            itemHtml += '           <div class="jobItemContent">';
            itemHtml += '               <div class="text">';
            itemHtml += '                   <div>';
            itemHtml += '                       ' + jobData.positionJobFilter.name + ' position<br>';
            itemHtml += '                       <span class="subtext">' + jobData.applicantsCount + ' applied</span>';
            itemHtml += '                   </div>';
            itemHtml += '               </div>';
            itemHtml += '               <div class="view"><a href="' + jobRoute + '" target="_blank">View</a></div>';
            itemHtml += '           </div>';
            itemHtml += '       </div>';

            itemsHtml += itemHtml;
        }

        return itemsHtml;
    },

    _showMapControls: function() {
        this._$view.find(".locationMsg").removeClass("hiddenControl");
        this._$view.find(".filtersControl").removeClass("hiddenControl");
    },

    _hideMapControls: function() {
        this._$view.find(".locationMsg").addClass("hiddenControl");
        this._$view.find(".filtersControl").addClass("hiddenControl");
    },

    _showNotificationIfNoJobsFound: function() {
        if(this._jobsData.length == 0)
            NtechApp.info.on("No available jobs found in selected area.", 2500);
    }
});